module.exports = __webpack_public_path__ + "static/media/simple_machines.124ab0ca.png";